export const _fr = {
    statuses: {
        discharged: {
            label: "Acquittée"
        },
        notDischarged: {
            label: "Non résolue"
        }
    },
    massDischargeBtn: {
        label: "Acquitter",
        tooltip: "Acquitter les alertes sélectionnées"
    },
    clearSelectionBtn: {
        label: "Vider la sélection",
        tooltip: "Déselectionner les lignes du tableau"
    },
    alertSummaryComputeButton: {
        label: "",
        tooltip: "Calculer les alertes"
    },
    tooltip: {
        externalLink: {
            title: "Aller à l'alerte"
        }
    },
    modal: {
        title: "Acquittement de l'alerte",
        addButton: {
            label: "Acquitter"
        }
    },
    table: {
        code: {
            label: "Code"
        },
        date: {
            label: "Date"
        },
        message: {
            label: "Message"
        },
        level: {
            label: "Niveau"
        },
        status: {
            label: "Statut"
        },
        comment: {
            label: "Commentaire"
        }
    }
};

export const _en = {
    statuses: {
        discharged: {
            label: "Acquitted"
        },
        notDischarged: {
            label: "Not acquitted"
        }
    },
    massDischargeBtn: {
        label: "Discharge",
        tooltip: "Discharge selected alerts"
    },
    clearSelectionBtn: {
        label: "Clear selection",
        tooltip: "unselect all rows"
    },
    alertSummaryComputeButton: {
        label: "",
        tooltip: "Compute alerts"
    },
    tooltip: {
        externalLink: {
            title: "Navigate to alert"
        }
    },
    modal: {
        title: "Acknowledgment of the alert",
        addButton: {
            label: "Acknowledgment"
        }
    },
    table: {
        code: {
            label: "Code"
        },
        date: {
            label: "Date"
        },
        message: {
            label: "Message"
        },
        level: {
            label: "Criticity level"
        },
        status: {
            label: "Status"
        },
        comment: {
            label: "Comment"
        }
    }
};